import React, { useState } from 'react';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import QuestionnaireConfirmExportModal from './QuestionnaireConfirmExportModal';
import { useExportQuestionnaire } from '../../Hooks/useExportQuestionnaire';

interface QuestionnaireExportButtonProps {
	questionnaireCode: string;
	patientId: string;
}

const QuestionnaireExportButton: React.FC<QuestionnaireExportButtonProps> = ({
	questionnaireCode,
	patientId,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const { exportQuestionnaire } = useExportQuestionnaire({
		questionnaireCode,
		patientId,
		afterExport: () => setIsOpen(false),
	});

	return (
		<>
			<LinkButton
				title='component.questionnaireExportModal.button'
				theme={Theme.BLUE}
				onClick={() => setIsOpen(true)}
			/>
			<QuestionnaireConfirmExportModal
				isOpen={isOpen}
				onClose={() => {
					setIsOpen(false);
				}}
				onConfirm={exportQuestionnaire}
				questionnaireCode={questionnaireCode}
				patientId={patientId}
			/>
		</>
	);
};

export default QuestionnaireExportButton;
